import Market from './components/Market';

export default Market;
